module.exports = __webpack_public_path__ + "img/logo_head.547184ed.svg";